import { useState } from "react";
import { motion } from "framer-motion";

export default function LearningAnalytics() {

const progress = 78;

const data=[
{day:"Mon",x:40,y:130,score:65},
{day:"Tue",x:120,y:115,score:72},
{day:"Wed",x:200,y:125,score:68},
{day:"Thu",x:280,y:90,score:85},
{day:"Fri",x:360,y:110,score:78},
{day:"Sat",x:440,y:70,score:92},
{day:"Sun",x:520,y:85,score:88},
];

const [tooltip,setTooltip]=useState(null);

const radius=70;
const circumference=2*Math.PI*radius;

return (

<section className="relative px-10 py-20">

<div className="max-w-7xl mx-auto">

<h2 className="text-4xl font-bold text-[#3A2A1A] mb-2">Learning Analytics</h2>
<p className="text-[#7A4A28] mb-12">Track your progress</p>

<div className="grid lg:grid-cols-3 gap-10">

{/* ================= LEFT DONUT ================= */}

<div className="paper-card rounded-2xl p-8">

<h3 className="text-xl mb-6">Overall Progress</h3>

<div className="flex justify-center mb-6 relative">

<svg width="180" height="180">

<circle cx="90" cy="90" r={radius} stroke="#e5d3b3" strokeWidth="14" fill="none"/>

<motion.circle
cx="90"
cy="90"
r={radius}
stroke="#f59e0b"
strokeWidth="14"
fill="none"
strokeDasharray={circumference}
strokeDashoffset={circumference}
animate={{strokeDashoffset:circumference-(progress/100)*circumference}}
transition={{duration:1.5}}
strokeLinecap="round"
transform="rotate(-90 90 90)"
/>

</svg>

<div className="absolute inset-0 flex items-center justify-center">
<span className="text-4xl font-bold text-orange-500">{progress}%</span>
</div>

</div>

<div className="space-y-3">

<div className="flex justify-between bg-white/30 rounded px-4 py-2">
<span>Accuracy</span>
<span className="text-orange-500 font-bold">92%</span>
</div>

<div className="flex justify-between bg-white/30 rounded px-4 py-2">
<span>Avg Time</span>
<span className="text-orange-500 font-bold">45 min</span>
</div>

</div>

</div>

{/* ================= RIGHT GRAPH ================= */}

<div className="paper-card rounded-2xl p-8 relative lg:col-span-2 z-10">


<h3 className="text-xl mb-4">Weekly Performance</h3>

<svg viewBox="0 0 600 300" className="w-full h-80 relative z-20">

{/* GRID */}

{[50,100,150,200].map(y=>(
<line key={y} x1="30" y1={y} x2="570" y2={y} stroke="#d9c7a6" strokeDasharray="4"/>
))}

{[40,120,200,280,360,440,520].map(x=>(
<line key={x} x1={x} y1="40" x2={x} y2="220" stroke="#d9c7a6" strokeDasharray="4"/>
))}

{/* LINE */}

<motion.polyline
initial={{pathLength:0}}
whileInView={{pathLength:1}}
transition={{duration:1.4}}
fill="none"
stroke="#f59e0b"
strokeWidth="4"
points={data.map(p=>`${p.x},${p.y}`).join(" ")}
/>

{/* DOTS */}

{data.map((p,i)=>(
<motion.circle
key={i}
cx={p.x}
cy={p.y}
r="6"
fill="#f59e0b"
whileHover={{scale:1.6}}
onMouseEnter={()=>setTooltip(p)}
onMouseLeave={()=>setTooltip(null)}
/>
))}

{/* DAY LABELS */}

{data.map((p,i)=>(
<text key={i} x={p.x-12} y="255" fontSize="12" fill="#9a7b4f">
{p.day}
</text>
))}

</svg>

{/* TOOLTIP */}

{tooltip && (
<motion.div
initial={{opacity:0,scale:.8}}
animate={{opacity:1,scale:1}}
className="absolute bg-[#f6e9d2] px-3 py-1 rounded text-sm shadow-lg z-50"
style={{
left: tooltip.x,
top: tooltip.y,
transform: "translate(-50%, -120%)"
}}
>
{tooltip.day}: {tooltip.score}%
</motion.div>
)}

</div>

</div>

</div>

</section>

);
}
